const React = require('react');
const { createElement: h, useState, useRef, useEffect } = React;
const ConfirmDialog = require('./ConfirmDialog');
const WorkflowVersionHistory = require('./WorkflowVersionHistory');
const WorkflowHttpRequests = require('./WorkflowHttpRequests');
const FeedbackWidget = require('./FeedbackWidget');
require('./Header.css');

function SparkleIcon() {
  return h('svg', { width: 16, height: 16, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.9, strokeLinecap: 'round', strokeLinejoin: 'round' },
    h('path', { d: 'M12 3l1.9 4.9L19 10l-5.1 2.1L12 17l-1.9-4.9L5 10l5.1-2.1z' }),
    h('path', { d: 'M19 3v3' }),
    h('path', { d: 'M20.5 4.5h-3' }),
    h('path', { d: 'M5 17v2.5' }),
    h('path', { d: 'M6.25 18.25h-2.5' })
  );
}

function ImportIcon() {
  return h('svg', { width: 15, height: 15, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' },
    h('path', { d: 'M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4' }),
    h('polyline', { points: '17 8 12 3 7 8' }),
    h('line', { x1: 12, y1: 3, x2: 12, y2: 15 })
  );
}

function ExportIcon() {
  return h('svg', { width: 15, height: 15, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' },
    h('path', { d: 'M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4' }),
    h('polyline', { points: '7 10 12 15 17 10' }),
    h('line', { x1: 12, y1: 15, x2: 12, y2: 3 })
  );
}

function SaveIcon() {
  return h('svg', { width: 15, height: 15, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' },
    h('path', { d: 'M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z' }),
    h('polyline', { points: '17 21 17 13 7 13 7 21' }),
    h('polyline', { points: '7 3 7 8 15 8' })
  );
}

function CodeIcon() {
  return h('svg', { width: 15, height: 15, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' },
    h('polyline', { points: '16 18 22 12 16 6' }),
    h('polyline', { points: '8 6 2 12 8 18' })
  );
}

function ListenIcon() {
  return h('svg', { width: 15, height: 15, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' },
    h('path', { d: 'M12 4a8 8 0 0 1 8 8' }),
    h('path', { d: 'M12 8a4 4 0 0 1 4 4' }),
    h('circle', { cx: 12, cy: 16, r: 1.5 }),
    h('path', { d: 'M12 19v1' }),
    h('path', { d: 'M4 12a8 8 0 0 1 8-8' })
  );
}

function HttpRequestsIcon() {
  return h('svg', { width: 15, height: 15, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' },
    h('path', { d: 'M4 8h13l-3-3' }),
    h('path', { d: 'M20 16H7l3 3' })
  );
}

function copyTextValue(value, onCopied) {
  if (!value) return;

  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(value).then(onCopied).catch(function() {});
    return;
  }

  var input = document.createElement('input');
  input.value = value;
  document.body.appendChild(input);
  input.select();
  try {
    document.execCommand('copy');
    onCopied();
  } catch (error) {}
  document.body.removeChild(input);
}

function buildPublicStreamRunUrl(publicRunUrl, streamCode) {
  var baseUrl = String(publicRunUrl || '').trim();
  var code = String(streamCode || '').trim();
  if (!baseUrl || !code) return '';
  return baseUrl + (baseUrl.indexOf('?') >= 0 ? '&' : '?') + '__showeventstream=' + encodeURIComponent(code);
}

function Header(props) {
  var workflowName = props && props.workflowName !== undefined && props.workflowName !== null
    ? String(props.workflowName)
    : 'Untitled';
  var onWorkflowNameChange = props && props.onWorkflowNameChange ? props.onWorkflowNameChange : function() {};
  var onWorkflowNameBlur = props && props.onWorkflowNameBlur ? props.onWorkflowNameBlur : function() {};
  var workbookName = props && props.workbookName !== undefined && props.workbookName !== null
    ? String(props.workbookName)
    : '';
  var onWorkbookNameChange = props && props.onWorkbookNameChange ? props.onWorkbookNameChange : null;
  var onWorkbookNameBlur = props && props.onWorkbookNameBlur ? props.onWorkbookNameBlur : function() {};
  var onRunWorkflow = props && typeof props.onRunWorkflow === 'function' ? props.onRunWorkflow : null;
  var isRunDisabled = !!(props && props.isRunDisabled);
  // Drives the feedback button's shake nudge (shakes when a run ends).
  var isExecutionRunning = !!(props && props.isExecutionRunning);
  var onOpenAiInstruction = props && typeof props.onOpenAiInstruction === 'function' ? props.onOpenAiInstruction : null;
  var onOpenWorkflowList = props && props.onOpenWorkflowList ? props.onOpenWorkflowList : null;
  var hasWorkbook = !!(props && props.hasWorkbook);
  var isWorkbookPanelOpen = !!(props && props.isWorkbookPanelOpen);
  var onToggleWorkbookPanel = props && props.onToggleWorkbookPanel ? props.onToggleWorkbookPanel : null;
  var onDeleteWorkflow = props && typeof props.onDeleteWorkflow === 'function' ? props.onDeleteWorkflow : null;
  var onDeleteWorkbook = props && typeof props.onDeleteWorkbook === 'function' ? props.onDeleteWorkbook : null;
  var onSaveWorkflow = props && typeof props.onSaveWorkflow === 'function' ? props.onSaveWorkflow : null;
  var onPublishToStore = props && typeof props.onPublishToStore === 'function' ? props.onPublishToStore : null;
  // Current published live version string (semver), or null when not published.
  var liveVersion = props && props.liveVersion ? String(props.liveVersion) : null;
  // Staging / Live view toggle. 'staging' (default, editable) or 'live'
  // (read-only view of the published version).
  var workflowMode = props && props.workflowMode === 'live' ? 'live' : 'staging';
  var onChangeWorkflowMode = props && typeof props.onChangeWorkflowMode === 'function' ? props.onChangeWorkflowMode : null;
  // Publish/update the live version from staging (opens the version dialog).
  var onUpdateLive = props && typeof props.onUpdateLive === 'function' ? props.onUpdateLive : null;
  var isLiveMode = workflowMode === 'live';
  var isSaved = !!(props && props.isSaved);
  var isSaving = !!(props && props.isSaving);
  // Default true so callers that don't track hydration are unaffected; App.js
  // passes the real flag so Save stays disabled until the flow has rendered.
  var isWorkflowHydrated = !(props && props.isWorkflowHydrated === false);
  var isExecutionRunning = !!(props && props.isExecutionRunning);
  var workflowId = props && props.workflowId ? String(props.workflowId) : '';
  var listWorkflowVersions = props && typeof props.listWorkflowVersions === 'function' ? props.listWorkflowVersions : null;
  var restoreWorkflowVersion = props && typeof props.restoreWorkflowVersion === 'function' ? props.restoreWorkflowVersion : null;
  var getLiveVersionMeta = props && typeof props.getLiveVersionMeta === 'function' ? props.getLiveVersionMeta : null;
  var listLiveVersionHistory = props && typeof props.listLiveVersionHistory === 'function' ? props.listLiveVersionHistory : null;
  var onRestoreWorkflowVersion = props && typeof props.onRestoreWorkflowVersion === 'function' ? props.onRestoreWorkflowVersion : null;
  var onExportWorkflow = props && typeof props.onExportWorkflow === 'function' ? props.onExportWorkflow : null;
  var onConvertToCode = props && typeof props.onConvertToCode === 'function' ? props.onConvertToCode : null;
  var onImportWorkflow = props && typeof props.onImportWorkflow === 'function' ? props.onImportWorkflow : null;
  var onClearWorkflow = props && typeof props.onClearWorkflow === 'function' ? props.onClearWorkflow : null;
  var onUndo = props && typeof props.onUndo === 'function' ? props.onUndo : null;
  var onRedo = props && typeof props.onRedo === 'function' ? props.onRedo : null;

  var publicRunUrl = props && props.publicRunUrl ? String(props.publicRunUrl) : '';
  var publicEventStreamEnabled = !!(props && props.publicEventStreamEnabled);
  var publicEventStreamCode = props && props.publicEventStreamCode ? String(props.publicEventStreamCode) : '';
  var publicEventStreamError = props && props.publicEventStreamError ? String(props.publicEventStreamError) : '';
  var publicEventStreamStatus = props && props.publicEventStreamStatus ? String(props.publicEventStreamStatus) : 'idle';
  var publicEventStreamLastEventAt = props && props.publicEventStreamLastEventAt ? String(props.publicEventStreamLastEventAt) : '';
  var onTogglePublicEventStream = props && typeof props.onTogglePublicEventStream === 'function' ? props.onTogglePublicEventStream : null;
  var onApplyPublicEventStreamCode = props && typeof props.onApplyPublicEventStreamCode === 'function'
    ? props.onApplyPublicEventStreamCode
    : null;
  var hasAiInstruction = !!(props && props.hasAiInstruction);
  var doctorChatOpen = !!(props && props.doctorChatOpen);
  var onToggleDoctorChat = props && typeof props.onToggleDoctorChat === 'function'
    ? props.onToggleDoctorChat
    : null;
  // Remote Support: sidebar toggle, live-agent count badge, and whether THIS
  // client is a support agent inside someone else's session (agents never
  // save/restore/publish — the owner's account stays untouched by them).
  var remoteSupportOpen = !!(props && props.remoteSupportOpen);
  var onToggleRemoteSupport = props && typeof props.onToggleRemoteSupport === 'function'
    ? props.onToggleRemoteSupport
    : null;
  var collabAgentCount = props && props.collabAgentCount ? Number(props.collabAgentCount) : 0;
  var isRemoteSupportAgent = !!(props && props.isRemoteSupportAgent);
  var isDark = !!(props && props.isDark);
  var onThemeToggle = props && typeof props.onThemeToggle === 'function' ? props.onThemeToggle : null;
  var startHyperparameters = props && Array.isArray(props.startHyperparameters) ? props.startHyperparameters : [];
  var workflowId = props && props.workflowId ? String(props.workflowId) : '';
  var isEmbed = !!(props && props.isEmbed);
  var [copied, setCopied] = useState(false);
  var [widgetCopied, setWidgetCopied] = useState(false);
  var [confirmClearOpen, setConfirmClearOpen] = useState(false);
  var [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  var [listenModalOpen, setListenModalOpen] = useState(false);
  var [httpRequestsOpen, setHttpRequestsOpen] = useState(false);
  var [menuOpen, setMenuOpen] = useState(false);
  var [streamCodeCopied, setStreamCodeCopied] = useState(false);
  // Manual stream code typed in the Listen modal; mirrors the active code.
  var [streamCodeInput, setStreamCodeInput] = useState(publicEventStreamCode);
  useEffect(function() { setStreamCodeInput(publicEventStreamCode); }, [publicEventStreamCode]);
  var trimmedStreamCodeInput = String(streamCodeInput || '').trim();
  var [streamUrlCopied, setStreamUrlCopied] = useState(false);
  var [curlPopupOpen, setCurlPopupOpen] = useState(false);
  var [curlMethod, setCurlMethod] = useState('POST');
  var [curlCopied, setCurlCopied] = useState(false);
  // Mobile-only: collapses the action icons into a kebab menu so the header
  // fits on narrow phones. Inert on desktop (CSS hides the trigger).
  var [actionsOpen, setActionsOpen] = useState(false);
  var curlPopupRef = useRef(null);
  var publicStreamRunUrl = buildPublicStreamRunUrl(publicRunUrl, publicEventStreamCode);
  var effectivePublicRunUrl = publicEventStreamEnabled && publicStreamRunUrl
    ? publicStreamRunUrl
    : publicRunUrl;

  // Build curl command from start hyperparameters
  var curlCommand = '';
  if (effectivePublicRunUrl) {
    var validParams = startHyperparameters.filter(function(p) { return p && p.key && p.key.trim(); });
    if (curlMethod === 'GET') {
      var queryParts = validParams.map(function(p) {
        var val = p.default !== undefined && p.default !== '' ? encodeURIComponent(p.default) : '';
        return encodeURIComponent(p.key) + '=' + val;
      });
      var getUrl = effectivePublicRunUrl + (queryParts.length ? (effectivePublicRunUrl.indexOf('?') >= 0 ? '&' : '?') + queryParts.join('&') : '');
      curlCommand = 'curl -X GET "' + getUrl + '"';
    } else {
      var bodyObj = {};
      validParams.forEach(function(p) {
        bodyObj[p.key] = p.default !== undefined && p.default !== '' ? p.default : '';
      });
      var bodyStr = JSON.stringify(bodyObj, null, 2);
      curlCommand = 'curl -X POST "' + effectivePublicRunUrl + '" \\\n  -H "Content-Type: application/json" \\\n  -d \'' + bodyStr + '\'';
    }
  }

  // Close curl popup on outside click
  useEffect(function() {
    function handleClickOutside(e) {
      if (curlPopupOpen && curlPopupRef.current && !curlPopupRef.current.contains(e.target)) {
        setCurlPopupOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return function() { document.removeEventListener('mousedown', handleClickOutside); };
  }, [curlPopupOpen]);

  function handleCopyPublicUrl() {
    if (!effectivePublicRunUrl) return;
    copyTextValue(effectivePublicRunUrl, function() {
      setCopied(true);
      setTimeout(function() { setCopied(false); }, 1200);
    });
  }

  function handleCopyStreamCode() {
    if (!publicEventStreamCode) return;
    copyTextValue(publicEventStreamCode, function() {
      setStreamCodeCopied(true);
      setTimeout(function() { setStreamCodeCopied(false); }, 1200);
    });
  }

  function handleCopyStreamUrl() {
    if (!publicStreamRunUrl) return;
    copyTextValue(publicStreamRunUrl, function() {
      setStreamUrlCopied(true);
      setTimeout(function() { setStreamUrlCopied(false); }, 1200);
    });
  }

  function handleCopyWidgetUrl() {
    if (!workflowId) return;
    var widgetUrl = window.location.origin + '/workflow/' + encodeURIComponent(workflowId) + '?embed=true';
    copyTextValue(widgetUrl, function() {
      setWidgetCopied(true);
      setTimeout(function() { setWidgetCopied(false); }, 1500);
    });
  }

  // ── Action buttons, defined once so the actions row can order them to match
  // the toolbar layout: [tools] · [History/Listen/Widget] · Save · Publish · ☰
  var menuBlock = h('div', { className: 'header-menu-wrap', key: 'menu' },
    h('button', {
      className: 'header-btn header-menu-trigger',
      onClick: function() { setMenuOpen(function(o) { return !o; }); },
      title: 'Workflow actions',
      'data-mobile-label': 'Workflow Actions'
    },
      h('svg', { width: 16, height: 16, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' },
        h('line', { x1: 3, y1: 6, x2: 21, y2: 6 }),
        h('line', { x1: 3, y1: 12, x2: 21, y2: 12 }),
        h('line', { x1: 3, y1: 18, x2: 21, y2: 18 })
      )
    ),
    menuOpen
      ? h('div', {
          className: 'header-menu-dropdown',
          onMouseDown: function(e) { e.stopPropagation(); },
          onTouchStart: function(e) { e.stopPropagation(); }
        },
          h('div', { className: 'header-menu-backdrop', onClick: function() { setMenuOpen(false); } }),
          onOpenAiInstruction && !isEmbed
            ? h('button', {
                className: 'header-menu-item' + (hasAiInstruction ? ' header-menu-item-active' : ''),
                onClick: function() { setMenuOpen(false); onOpenAiInstruction(); },
                title: hasAiInstruction ? 'Edit AI instruction' : 'Add AI instruction'
              },
                h(SparkleIcon),
                h('span', null, hasAiInstruction ? 'Edit AI Instruction' : 'Add AI Instruction')
              )
            : null,
          workflowId && !isEmbed
            ? h('button', {
                className: 'header-menu-item',
                onClick: function() { handleCopyWidgetUrl(); },
                title: 'Copy public embed URL for this workflow'
              },
                h('svg', { width: 15, height: 15, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' },
                  h('rect', { x: 3, y: 4, width: 18, height: 14, rx: 2 }),
                  h('path', { d: 'M3 9h18' }),
                  h('circle', { cx: 6.5, cy: 6.5, r: 0.6, fill: 'currentColor' }),
                  h('circle', { cx: 9, cy: 6.5, r: 0.6, fill: 'currentColor' })
                ),
                h('span', null, widgetCopied ? 'Copied!' : 'Widget')
              )
            : null,
          // Log of the calls made to this workflow's public run URL. Support
          // agents are excluded — the log belongs to the session owner.
          publicRunUrl && workflowId && !isEmbed && !isRemoteSupportAgent
            ? h('button', {
                className: 'header-menu-item',
                onClick: function() { setMenuOpen(false); setHttpRequestsOpen(true); },
                title: 'HTTP requests sent to this workflow'
              },
                h(HttpRequestsIcon),
                h('span', null, 'HTTP Requests')
              )
            : null,
          publicRunUrl && onTogglePublicEventStream
            ? h('button', {
                className: 'header-menu-item' + (publicEventStreamEnabled ? ' header-menu-item-active' : ''),
                onClick: function() { setMenuOpen(false); setListenModalOpen(true); },
                title: publicEventStreamEnabled ? 'Listening to public workflow events' : 'Listen for public workflow events'
              },
                h(ListenIcon),
                h('span', null, publicEventStreamEnabled ? 'Listening' : 'Listen')
              )
            : null,
          onThemeToggle
            ? h('button', {
                className: 'header-menu-item',
                onClick: function() { setMenuOpen(false); onThemeToggle(); },
                title: isDark ? 'Switch to light mode' : 'Switch to dark mode'
              },
                isDark
                  ? h('svg', { width: 15, height: 15, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' },
                      h('circle', { cx: 12, cy: 12, r: 5 }),
                      h('line', { x1: 12, y1: 1, x2: 12, y2: 3 }),
                      h('line', { x1: 12, y1: 21, x2: 12, y2: 23 }),
                      h('line', { x1: 4.22, y1: 4.22, x2: 5.64, y2: 5.64 }),
                      h('line', { x1: 18.36, y1: 18.36, x2: 19.78, y2: 19.78 }),
                      h('line', { x1: 1, y1: 12, x2: 3, y2: 12 }),
                      h('line', { x1: 21, y1: 12, x2: 23, y2: 12 }),
                      h('line', { x1: 4.22, y1: 19.78, x2: 5.64, y2: 18.36 }),
                      h('line', { x1: 18.36, y1: 5.64, x2: 19.78, y2: 4.22 })
                    )
                  : h('svg', { width: 15, height: 15, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' },
                      h('path', { d: 'M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z' })
                    ),
                h('span', null, isDark ? 'Light Mode' : 'Dark Mode')
              )
            : null,
          onImportWorkflow
            ? h('button', { className: 'header-menu-item', onClick: function() { setMenuOpen(false); onImportWorkflow(); } },
                h(ImportIcon),
                h('span', null, 'Import')
              )
            : null,
          onExportWorkflow
            ? h('button', { className: 'header-menu-item', onClick: function() { setMenuOpen(false); onExportWorkflow(); } },
                h(ExportIcon),
                h('span', null, 'Export')
              )
            : null,
          onConvertToCode && !isEmbed
            ? h('button', {
                className: 'header-menu-item',
                onClick: function() { setMenuOpen(false); onConvertToCode(); },
                title: 'Download this workflow as a Node.js file'
              },
                h(CodeIcon),
                h('span', null, 'Convert to Code')
              )
            : null,
          onClearWorkflow
            ? h('button', { className: 'header-menu-item header-menu-item-danger', onClick: function() { setMenuOpen(false); setConfirmClearOpen(true); } },
                h('svg', { width: 15, height: 15, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' },
                  h('path', { d: 'M3 6h18' }),
                  h('path', { d: 'M8 6V4h8v2' }),
                  h('path', { d: 'M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6' })
                ),
                h('span', null, 'Clear')
              )
            : null,
          (hasWorkbook && !isEmbed ? onDeleteWorkbook : onDeleteWorkflow)
            ? h('button', { className: 'header-menu-item header-menu-item-danger', onClick: function() { setMenuOpen(false); setConfirmDeleteOpen(true); } },
                h('svg', { width: 15, height: 15, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' },
                  h('path', { d: 'M3 6h18' }),
                  h('path', { d: 'M8 6V4h8v2' }),
                  h('path', { d: 'M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6' })
                ),
                h('span', null, 'Delete')
              )
            : null
        )
      : null
  );

  var saveBlock = onSaveWorkflow
    ? h('button', {
        key: 'save',
        className: 'header-btn header-text-btn header-save-btn'
          + (isSaved ? ' header-save-btn-saved' : '')
          + (isSaving ? ' header-save-btn-saving' : ''),
        onClick: onSaveWorkflow,
        disabled: isSaving || !isWorkflowHydrated || isExecutionRunning,
        title: !isWorkflowHydrated
          ? 'Loading workflow…'
          : (isExecutionRunning
              ? 'Saving is disabled while the workflow is running'
              : (isSaving
                  ? 'Saving…'
                  : (isSaved ? 'All changes saved' : 'Draft auto-saved locally — click to save to server (Ctrl+S / Cmd+S)')))
      },
        isSaving
          ? h('span', { className: 'header-save-spinner', 'aria-hidden': 'true' })
          : h(SaveIcon),
        h('span', { className: 'header-btn-label' },
          isSaving ? 'Saving…' : (isSaved ? 'Saved' : 'Save')
        ),
        !isSaved && !isSaving
          ? h('span', { className: 'header-save-draft-hint', title: 'Your edits are auto-saved as a local draft. Click Save to push to the server.' }, 'Draft')
          : null
      )
    : null;

  // Staging / Live segmented toggle. Staging is the editable canvas; Live shows
  // the published (read-only) version. The badge on Live shows its version.
  var modeToggleBlock = onChangeWorkflowMode && workflowId && !isEmbed
    ? h('div', { key: 'modetoggle', className: 'header-mode-toggle', role: 'tablist' },
        h('button', {
          type: 'button',
          className: 'header-mode-tab' + (!isLiveMode ? ' header-mode-tab-active' : ''),
          onClick: function() { if (isLiveMode) onChangeWorkflowMode('staging'); },
          title: 'Edit the staging version'
        }, 'Staging'),
        h('button', {
          type: 'button',
          className: 'header-mode-tab' + (isLiveMode ? ' header-mode-tab-active' : ''),
          onClick: function() { if (!isLiveMode) onChangeWorkflowMode('live'); },
          title: liveVersion ? ('View the live version (v' + liveVersion + ')') : 'View the live version'
        },
          'Live',
          liveVersion ? h('span', { className: 'header-mode-tab-badge' }, 'v' + liveVersion) : null
        )
      )
    : null;

  // "Publish to store": only in Live mode (you publish the production version to
  // the Template Store, not staging). The "Update from staging" action lives in
  // the on-canvas LIVE banner, so there's no separate header Update button.
  var publishStoreBlock = isLiveMode && onPublishToStore && workflowId && !isEmbed
    ? h('button', {
        key: 'publishstore',
        className: 'header-btn header-text-btn',
        onClick: onPublishToStore,
        title: 'Publish the live version to the Template Store'
      },
        h('svg', { width: 15, height: 15, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' },
          h('path', { d: 'M12 19V6' }),
          h('path', { d: 'M5 12l7-7 7 7' })
        ),
        h('span', { className: 'header-btn-label' }, 'Publish to store')
      )
    : null;

  var historyBlock = workflowId && !isEmbed && listWorkflowVersions && restoreWorkflowVersion
    ? h(WorkflowVersionHistory, {
        key: 'history',
        workflowId: workflowId,
        listVersions: listWorkflowVersions,
        restoreVersion: restoreWorkflowVersion,
        onRestored: onRestoreWorkflowVersion || function() {},
        getLiveVersion: getLiveVersionMeta,
        listLiveHistory: listLiveVersionHistory
      })
    : null;

  var curlBlock = publicRunUrl
    ? h('div', { className: 'header-curl-wrap', ref: curlPopupRef, key: 'curl' },
        h('button', {
          className: 'header-btn header-copy-url-btn' + (curlPopupOpen ? ' header-copy-url-btn-active' : ''),
          onClick: function() { setCurlPopupOpen(function(o) { return !o; }); },
          title: 'Show curl preview',
          'data-mobile-label': 'cURL'
        },
          h('svg', { width: 17, height: 17, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2 },
            h('rect', { x: 9, y: 9, width: 13, height: 13, rx: 2 }),
            h('path', { d: 'M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1' })
          )
        ),
        curlPopupOpen
          ? h('div', { className: 'header-curl-popup' },
              h('div', { className: 'header-curl-head' },
                h('div', { className: 'header-curl-title' }, 'cURL Preview'),
                h('div', { className: 'header-curl-tabs' },
                  h('button', {
                    className: 'header-curl-tab' + (curlMethod === 'GET' ? ' header-curl-tab-active' : ''),
                    onClick: function() { setCurlMethod('GET'); setCurlCopied(false); }
                  }, 'GET'),
                  h('button', {
                    className: 'header-curl-tab' + (curlMethod === 'POST' ? ' header-curl-tab-active' : ''),
                    onClick: function() { setCurlMethod('POST'); setCurlCopied(false); }
                  }, 'POST')
                )
              ),
              h('pre', { className: 'header-curl-code' }, curlCommand),
              // The public run endpoint executes the LIVE (published) snapshot.
              // With no live version yet the cURL would have nothing to run, so
              // offer to create one instead of letting the user copy a dead URL.
              !liveVersion
                ? h('div', { className: 'header-curl-foot' },
                    h('div', { className: 'header-curl-note' }, 'Publish a live version to make this endpoint runnable.'),
                    onUpdateLive
                      ? h('button', {
                          className: 'header-curl-live-btn',
                          onClick: function() {
                            setCurlPopupOpen(false);
                            onUpdateLive();
                          }
                        },
                          h('svg', { width: 14, height: 14, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' },
                            h('circle', { cx: 12, cy: 12, r: 9 }),
                            h('path', { d: 'M10 8l6 4-6 4V8z' })
                          ),
                          'Create live version'
                        )
                      : null
                  )
                : h('button', {
                    className: 'header-curl-copy-btn',
                    onClick: function() {
                      copyTextValue(curlCommand, function() {
                        setCurlCopied(true);
                        setTimeout(function() { setCurlCopied(false); }, 1500);
                      });
                    }
                  },
                    h('svg', { width: 14, height: 14, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2 },
                      h('rect', { x: 9, y: 9, width: 13, height: 13, rx: 2 }),
                      h('path', { d: 'M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1' })
                    ),
                    curlCopied ? 'Copied!' : 'Copy'
                  )
            )
          : null
      )
    : null;

  // Live mode is read-only — the Doctor can apply fixes to the workflow, so it's
  // disabled there (matches the canvas being locked in Live).
  var doctorBlock = onToggleDoctorChat && !isEmbed
    ? h('button', {
        key: 'doctor',
        className: 'header-btn header-doctor-btn' + (doctorChatOpen ? ' header-doctor-btn-active' : ''),
        onClick: isLiveMode ? undefined : onToggleDoctorChat,
        disabled: isLiveMode,
        title: isLiveMode
          ? 'Workflow Doctor is disabled in Live mode (read-only)'
          : (doctorChatOpen ? 'Close Workflow Doctor' : 'Open Workflow Doctor'),
        'data-mobile-label': 'Workflow Doctor'
      },
        h('svg', { width: 16, height: 16, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' },
          h('path', { d: 'M12 20h9' }),
          h('path', { d: 'M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z' })
        )
      )
    : null;

  // Remote Support toggle: owner manages support agents / sees who's in the
  // session; a joined agent sees the session roster. Badge = live agent count.
  var remoteSupportBlock = onToggleRemoteSupport && !isEmbed
    ? h('button', {
        key: 'remotesupport',
        className: 'header-btn header-remote-support-btn' + (remoteSupportOpen ? ' header-remote-support-btn-active' : ''),
        onClick: onToggleRemoteSupport,
        title: remoteSupportOpen ? 'Close Remote Support' : 'Remote Support — invite a support agent to work with you live',
        'data-mobile-label': 'Remote Support'
      },
        h('svg', { width: 16, height: 16, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' },
          h('path', { d: 'M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4' }),
          h('path', { d: 'M13 3h6a2 2 0 012 2v14a2 2 0 01-2 2h-6' }),
          h('path', { d: 'M12 8l4 4-4 4' }),
          h('path', { d: 'M16 12H7' })
        ),
        collabAgentCount > 0
          ? h('span', { className: 'header-remote-support-badge' }, String(collabAgentCount))
          : null
      )
    : null;

  function dividerKey(k) {
    return h('span', { className: 'header-divider', 'aria-hidden': 'true', key: k });
  }

  // In-app feedback launcher (shakes to invite feedback; opens the popup).
  var feedbackBlock = !isEmbed
    ? h(FeedbackWidget, { key: 'feedback', isExecutionRunning: isExecutionRunning })
    : null;

  // Left tools cluster (icon-only): feedback · cURL.
  // (AI Instruction, Widget, Listen and Theme now live in the ☰ menu.)
  // Workflow Doctor button hidden — the pencil icon was removed from the header.
  var toolsGroup = [remoteSupportBlock, feedbackBlock, isRemoteSupportAgent ? null : curlBlock].filter(Boolean);
  // Middle cluster: History · Staging/Live toggle. Support agents get neither
  // (both read/write the OWNER's server-side workflow, which agents can't touch).
  var infoGroup = (isRemoteSupportAgent ? [] : [historyBlock, modeToggleBlock]).filter(Boolean);
  // Right primary cluster: in Staging show Save; in Live show Publish to store
  // (Live is read-only, so Save is hidden; "Update from staging" lives in the
  // on-canvas LIVE banner, so no separate header Update button). Support
  // agents never see Save — only the session owner persists.
  var primaryGroup = (isRemoteSupportAgent ? [] : (isLiveMode ? [publishStoreBlock] : [saveBlock])).filter(Boolean);

  var actionsChildren = [];
  toolsGroup.forEach(function(b) { actionsChildren.push(b); });
  if (toolsGroup.length && (infoGroup.length || primaryGroup.length)) actionsChildren.push(dividerKey('d1'));
  infoGroup.forEach(function(b) { actionsChildren.push(b); });
  if (infoGroup.length && primaryGroup.length) actionsChildren.push(dividerKey('d2'));
  primaryGroup.forEach(function(b) { actionsChildren.push(b); });
  if ((toolsGroup.length || infoGroup.length || primaryGroup.length)) actionsChildren.push(dividerKey('d3'));
  actionsChildren.push(menuBlock);

  return h(React.Fragment, null,
    h('header', { className: 'header' },
      h('div', { className: 'header-left' },
        onOpenWorkflowList && !isEmbed
          ? h('button', { className: 'header-nav-btn header-back-btn', onClick: onOpenWorkflowList, title: 'Back to workflows' },
              h('svg', { width: 18, height: 18, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' },
                h('path', { d: 'M15 18l-6-6 6-6' })
              )
            )
          : null,
        (hasWorkbook && onToggleWorkbookPanel && !isEmbed)
          ? h('button', {
              className: 'header-nav-btn' + (isWorkbookPanelOpen ? ' header-nav-btn--active' : ''),
              onClick: function(e) { e.stopPropagation(); onToggleWorkbookPanel(); },
              title: 'Toggle playbook explorer'
            },
              h('svg', { width: 18, height: 18, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' },
                h('line', { x1: 3, y1: 6, x2: 21, y2: 6 }),
                h('line', { x1: 3, y1: 12, x2: 21, y2: 12 }),
                h('line', { x1: 3, y1: 18, x2: 21, y2: 18 })
              )
            )
          : null,
        (onUndo || onRedo)
          ? h('div', { className: 'header-nav-btns' },
              onUndo
                ? h('button', { className: 'header-nav-btn', onClick: onUndo, title: 'Undo' },
                    h('svg', { width: 16, height: 16, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2 },
                      h('path', { d: 'M1 4v6h6' }),
                      h('path', { d: 'M3.51 15a9 9 0 102.13-9.36L1 10' })
                    )
                  )
                : null,
              onRedo
                ? h('button', { className: 'header-nav-btn', onClick: onRedo, title: 'Redo' },
                    h('svg', { width: 16, height: 16, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2 },
                      h('path', { d: 'M23 4v6h-6' }),
                      h('path', { d: 'M20.49 15a9 9 0 11-2.12-9.36L23 10' })
                    )
                  )
                : null
            )
          : null,
        h('div', { className: 'header-title-group' },
          h('h1', { className: 'header-title' },
            (function() {
              // When the editor is opened inside a workbook, the header title
              // shows (and edits) the WORKBOOK name. The flow's own name lives
              // in the workbook explorer panel and can be renamed there.
              var showingWorkbook = hasWorkbook && !isEmbed;
              var displayValue = showingWorkbook ? workbookName : workflowName;
              var placeholder = showingWorkbook ? 'Untitled playbook' : 'Untitled';

              if (isEmbed) {
                return h('span', { className: 'header-title-input header-title-readonly' }, workflowName || 'Untitled');
              }

              if (showingWorkbook) {
                return h('input', {
                  className: 'header-title-input',
                  type: 'text',
                  value: displayValue,
                  placeholder: placeholder,
                  size: Math.max(8, (displayValue || placeholder).length + 1),
                  onChange: function(event) {
                    if (typeof onWorkbookNameChange === 'function') onWorkbookNameChange(event.target.value);
                  },
                  onBlur: onWorkbookNameBlur,
                  onMouseDown: function(event) { event.stopPropagation(); },
                  disabled: typeof onWorkbookNameChange !== 'function'
                });
              }

              return h('input', {
                className: 'header-title-input',
                type: 'text',
                value: workflowName,
                placeholder: 'Untitled',
                size: Math.max(8, (workflowName || 'Untitled').length + 1),
                onChange: function(event) { onWorkflowNameChange(event.target.value); },
                onBlur: onWorkflowNameBlur,
                onMouseDown: function(event) { event.stopPropagation(); }
              });
            })()
          )
        )
      ),
      !isEmbed ? h('button', {
          className: 'header-mobile-more-btn' + (actionsOpen ? ' header-mobile-more-btn-active' : ''),
          onClick: function() { setActionsOpen(function(o) { return !o; }); },
          title: 'More actions',
          'aria-label': 'More actions'
        },
          h('svg', { width: 18, height: 18, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2.2, strokeLinecap: 'round', strokeLinejoin: 'round' },
            h('circle', { cx: 12, cy: 5, r: 1 }),
            h('circle', { cx: 12, cy: 12, r: 1 }),
            h('circle', { cx: 12, cy: 19, r: 1 })
          )
        ) : null,
      !isEmbed && actionsOpen
        ? h('div', {
            className: 'header-actions-backdrop',
            onClick: function() { setActionsOpen(false); }
          })
        : null,
      !isEmbed ? h('div', { className: 'header-actions' + (actionsOpen ? ' header-actions-open' : '') },
        actionsOpen
          ? h('button', {
              type: 'button',
              className: 'header-actions-close',
              onClick: function() { setActionsOpen(false); },
              title: 'Close menu',
              'aria-label': 'Close menu'
            },
              h('svg', { width: 18, height: 18, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2.2, strokeLinecap: 'round', strokeLinejoin: 'round' },
                h('line', { x1: 18, y1: 6, x2: 6, y2: 18 }),
                h('line', { x1: 6, y1: 6, x2: 18, y2: 18 })
              )
            )
          : null,
        actionsChildren
      ) : null
    ),
    httpRequestsOpen
      ? h(WorkflowHttpRequests, {
          workflowId: workflowId,
          // Same target as the cURL preview: live, or staging while listening.
          runUrl: effectivePublicRunUrl,
          startHyperparameters: startHyperparameters,
          onClose: function() { setHttpRequestsOpen(false); }
        })
      : null,
    listenModalOpen
      ? h('div', {
          className: 'header-stream-modal-overlay',
          onMouseDown: function() { setListenModalOpen(false); }
        },
          h('div', {
            className: 'header-stream-modal',
            onMouseDown: function(event) { event.stopPropagation(); }
          },
            h('div', { className: 'header-stream-modal-head' },
              h('div', null,
                h('div', { className: 'header-stream-modal-title' }, 'Public Event Listener'),
                h('div', { className: 'header-stream-modal-subtitle' }, 'Mirror public endpoint runs into this workflow canvas.')
              ),
              h('button', {
                className: 'header-stream-close-btn',
                onClick: function() { setListenModalOpen(false); },
                title: 'Close'
              }, '\u00d7')
            ),
            h('div', { className: 'header-stream-toggle-row' },
              h('div', { className: 'header-stream-toggle-copy' },
                h('div', { className: 'header-stream-toggle-title' }, 'Listen mode'),
                h('div', { className: 'header-stream-toggle-text' }, 'When enabled, the builder switches to listening mode until you turn it off.')
              ),
              h('button', {
                type: 'button',
                className: 'header-stream-switch' + (publicEventStreamEnabled ? ' header-stream-switch-on' : ''),
                onClick: function() { onTogglePublicEventStream(!publicEventStreamEnabled, trimmedStreamCodeInput); },
                disabled: !publicEventStreamEnabled && !trimmedStreamCodeInput,
                'aria-pressed': publicEventStreamEnabled ? 'true' : 'false'
              },
                h('span', { className: 'header-stream-switch-knob' })
              )
            ),
            h('div', { className: 'header-stream-field' },
              h('div', { className: 'header-stream-field-label' }, 'Stream code'),
              h('input', {
                type: 'text',
                className: 'header-stream-code-input',
                value: streamCodeInput,
                placeholder: 'Enter the stream code to listen for',
                spellCheck: false,
                onChange: function(event) { setStreamCodeInput(event.target.value); }
              }),
              h('div', { className: 'header-stream-field-actions' },
                h('button', {
                  className: 'header-stream-copy-btn',
                  onClick: handleCopyStreamCode,
                  disabled: !publicEventStreamCode
                }, streamCodeCopied ? 'Copied' : 'Copy code'),
                publicEventStreamEnabled && onApplyPublicEventStreamCode && trimmedStreamCodeInput !== publicEventStreamCode
                  ? h('button', {
                      className: 'header-stream-copy-btn header-stream-regenerate-btn',
                      onClick: function() { onApplyPublicEventStreamCode(trimmedStreamCodeInput); },
                      disabled: !trimmedStreamCodeInput
                    }, 'Use this code')
                  : null
              )
            ),
            publicEventStreamEnabled
              ? h(React.Fragment, null,
                  h('div', { className: 'header-stream-field' },
                    h('div', { className: 'header-stream-field-label' }, 'Public run URL'),
                    h('div', { className: 'header-stream-field-value header-stream-field-value-url' }, publicStreamRunUrl || 'Waiting for stream code...'),
                    h('button', {
                      className: 'header-stream-copy-btn',
                      onClick: handleCopyStreamUrl,
                      disabled: !publicStreamRunUrl
                    }, streamUrlCopied ? 'Copied' : 'Copy URL')
                  ),
                  h('div', { className: 'header-stream-meta' },
                    h('div', { className: 'header-stream-meta-row' },
                      h('span', { className: 'header-stream-meta-label' }, 'Status'),
                      h('span', { className: 'header-stream-meta-value header-stream-meta-value-' + publicEventStreamStatus }, publicEventStreamStatus)
                    ),
                    h('div', { className: 'header-stream-meta-row' },
                      h('span', { className: 'header-stream-meta-label' }, 'Last event'),
                      h('span', { className: 'header-stream-meta-value' }, publicEventStreamLastEventAt ? new Date(publicEventStreamLastEventAt).toLocaleTimeString() : 'Waiting')
                    )
                  ),
                  h('div', { className: 'header-stream-help' }, 'Call the public run endpoint with this code in __showeventstream and the canvas will follow that execution live.'),
                  publicEventStreamError
                    ? h('div', { className: 'header-stream-error' }, publicEventStreamError)
                    : null
                )
              : h(React.Fragment, null,
                  h('div', { className: 'header-stream-help' }, 'Enter a stream code above, then turn this on to wait for live events sent to the public run endpoint with that code.'),
                  publicEventStreamError
                    ? h('div', { className: 'header-stream-error' }, publicEventStreamError)
                    : null
                ),
            h('div', { className: 'header-stream-modal-actions' },
              h('button', {
                className: 'header-btn header-text-btn',
                onClick: function() { setListenModalOpen(false); }
              }, 'Close')
            )
          )
        )
      : null,
    confirmClearOpen
      ? h(ConfirmDialog, {
          title: 'Clear workflow?',
          message: 'This will remove all nodes and connections from the current workflow canvas.',
          confirmLabel: 'Clear',
          cancelLabel: 'Cancel',
          danger: true,
          onConfirm: function() {
            setConfirmClearOpen(false);
            onClearWorkflow();
          },
          onCancel: function() {
            setConfirmClearOpen(false);
          }
        })
      : null
    ,
    confirmDeleteOpen && (hasWorkbook && !isEmbed ? onDeleteWorkbook : onDeleteWorkflow)
      ? (function() {
          var deletingWorkbook = hasWorkbook && !isEmbed && !!onDeleteWorkbook;
          return h(ConfirmDialog, {
            title: deletingWorkbook ? 'Delete playbook?' : 'Delete workflow?',
            message: deletingWorkbook
              ? 'This will permanently delete "' + (workbookName || 'this playbook') + '" along with all flows it contains. This cannot be undone.'
              : 'This will permanently delete the current workflow and return you to the workflow list.',
            confirmLabel: 'Delete',
            cancelLabel: 'Cancel',
            danger: true,
            onConfirm: function() {
              setConfirmDeleteOpen(false);
              if (deletingWorkbook) onDeleteWorkbook();
              else onDeleteWorkflow(workflowId);
            },
            onCancel: function() {
              setConfirmDeleteOpen(false);
            }
          });
        })()
      : null
  );
}

module.exports = Header;
